import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
    paper: {
        paddingTop: '15px',
        paddingLeft: '35px',
        paddingRight: '35px',
        paddingBottom: '25px',
    },
    paperFirst: {
        paddingTop: '0px',
        paddingLeft: '35px',
        paddingRight: '35px',
        paddingBottom: '25px',
        marginBottom: '20px',
    },
    paperHeader: {
        flexDirection: 'row-reverse'
    },
    paperTitle: {
        color: '#428302'
    },
    paperHeaderIcon: {
        color: '#428302'
    },
    gridContainer: {
        width: '100%'
    },
    dataLabel: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        color: theme.palette.text.secondary
    },
    sectionTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.main
    },
    noDataText: {
        fontStyle: 'italic',
        color: theme.palette.text.disabled
    }
}));
